import { useContext } from 'preact/hooks';
import { AppContext } from '@/context/appContext';

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within an AppContextProvider');
  }
  return context;
};